<div class="tool-host" *ngIf="known">
  <div class="th-header">
    <button class="th-back" (click)="back()" [attr.aria-label]="'shell.tool.back' | translate">
      <span class="th-back-box">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="15 18 9 12 15 6" /></svg>
      </span>
    </button>
    <div class="th-title">{{ name }}</div>
    <span class="th-spacer" aria-hidden="true"></span>
  </div>

  <p class="th-intro">{{ intro }}</p>

  <!-- Real, interactive tool when registered. While its import() resolves
       (hasTool && !toolCmp) render nothing — no "coming soon" flash. Stub
       shows ONLY for ids with no registered tool. -->
  <ng-container *ngIf="toolCmp">
    <ng-container *ngComponentOutlet="toolCmp"></ng-container>
  </ng-container>

  <ng-container *ngIf="!hasTool">
    <div class="th-soon">
      <div class="th-soon-title">{{ 'shell.tool.comingSoon' | translate }}</div>
      <div class="th-soon-sub">{{ 'shell.tool.comingSoonSub' | translate }}</div>
    </div>

    <button class="th-done" [disabled]="busy" (click)="markDone()">
      {{ 'shell.tool.markDone' | translate }}
    </button>
  </ng-container>

  <div class="th-disc">{{ disclaimerKey | translate }}</div>
</div>
